import React, { useRef } from "react";
import { Editor, EditorProvider } from "react-simple-wysiwyg";

const RichEditorField = ({ input, label, meta: { touched, error, valid }, disabled, required, description }) => {
  const editorRef = useRef(null);

  // Função para lidar com mudanças no editor
  const handleChange = (e) => {
    input.onChange(e.target.value);
  };

  // Função para aplicar comandos de formatação
  const executeCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    if (editorRef.current) {
      editorRef.current.focus();
    }
  };

  // Estilo para o container do editor baseado no estado de validação
  const getEditorContainerStyle = () => {
    if (touched && !valid) {
      return { border: "1px solid #dc3545", borderRadius: "4px" };
    } else if (required && valid && input.value) {
      return { border: "1px solid #28a745", borderRadius: "4px" };
    } else if (required) {
      return { border: "1px solid #e4e5e7", borderRadius: "4px" };
    }
    return { border: "1px solid #ccc", borderRadius: "4px" };
  };

  // Estilo para o editor com altura limitada e barra de rolagem
  const editorStyle = {
    minHeight: "200px",
    maxHeight: "400px", // Limita a altura máxima
    padding: "10px",
    width: "100%",
    overflowY: "auto", // Adiciona barra de rolagem vertical quando necessário
  };

  // Estilo para o conteúdo editável dentro do editor
  const editableContentStyle = {
    minHeight: "180px", // Um pouco menor que o minHeight do container
    outline: "none",
  };

  // Barra de ferramentas personalizada
  const CustomToolbar = () => (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#f8f9fa",
        padding: "5px",
        borderBottom: "1px solid #ddd",
      }}
    >
      {/* Formatação de texto */}
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("bold")} style={{ margin: "0 2px" }}>
        <i className="fa fa-bold"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("italic")} style={{ margin: "0 2px" }}>
        <i className="fa fa-italic"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("underline")} style={{ margin: "0 2px" }}>
        <i className="fa fa-underline"></i>
      </button>

      {/* Separador */}
      <div
        style={{
          borderLeft: "1px solid #ccc",
          height: "24px",
          margin: "0 5px",
        }}
      ></div>

      {/* Alinhamento de texto */}
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("justifyLeft")} style={{ margin: "0 2px" }}>
        <i className="fa fa-align-left"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("justifyCenter")} style={{ margin: "0 2px" }}>
        <i className="fa fa-align-center"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("justifyRight")} style={{ margin: "0 2px" }}>
        <i className="fa fa-align-right"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("justifyFull")} style={{ margin: "0 2px" }}>
        <i className="fa fa-align-justify"></i>
      </button>

      {/* Separador */}
      <div
        style={{
          borderLeft: "1px solid #ccc",
          height: "24px",
          margin: "0 5px",
        }}
      ></div>

      {/* Listas */}
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("insertUnorderedList")} style={{ margin: "0 2px" }}>
        <i className="fa fa-list-ul"></i>
      </button>
      <button type="button" className="btn btn-sm btn-light mr-1" onClick={() => executeCommand("insertOrderedList")} style={{ margin: "0 2px" }}>
        <i className="fa fa-list-ol"></i>
      </button>
    </div>
  );

  return (
    <div className={`form-group ${touched && !valid ? "has-error" : ""}`}>
      <label className="font-weight-bold">{label}</label>
      <div style={getEditorContainerStyle()}>
        {!disabled && <CustomToolbar />}
        <EditorProvider>
          <div ref={editorRef} style={editorStyle}>
            <Editor
              value={input.value || ""}
              onChange={handleChange}
              onBlur={() => input.onBlur(input.value)}
              disabled={disabled}
              containerProps={{ style: editableContentStyle }}
              hideToolbar={true} // Ocultar a barra de ferramentas padrão
            />
          </div>
        </EditorProvider>
      </div>
      {description && <span className="help-block small">{description}</span>}
      <p className="text-danger">{touched ? error : ""}</p>
    </div>
  );
};

export default RichEditorField;
